export default __webpack_public_path__ + "static/media/hair-9-5.655c1054.svg";